// Compatibility layer for posthog-js/react hooks
import { useLegacyPostHog } from 'contexts/PostHogContext';

// Export the legacy hook for direct posthog instance access (for backward compatibility)
export const usePostHog = () => {
  return useLegacyPostHog();
};

// Compatibility hook for useFeatureFlagEnabled
export const useFeatureFlagEnabled = (flagKey) => {
  const posthog = useLegacyPostHog();

  // If PostHog isn't loaded yet, return false (default state)
  if (!posthog) {
    return false;
  }

  // Use PostHog's feature flag functionality
  return posthog.isFeatureEnabled(flagKey);
};

// Compatibility hook for useFeatureFlagPayload
export const useFeatureFlagPayload = (flagKey) => {
  const posthog = useLegacyPostHog();

  // If PostHog isn't loaded yet, return undefined
  if (!posthog) {
    return undefined;
  }

  // Use PostHog's feature flag payload functionality
  return posthog.getFeatureFlagPayload(flagKey);
};
